module.exports = __webpack_public_path__ + "static/media/02.8c29b54b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/02.jpg
// module id = 564
// module chunks = 0